import moment from 'moment'
import masterData from 'src/utils/mappings/masterData'
import MemberPersonalDataHeirarchicalMixin from './memberPersonalDataHeirarchicalMixin'
import ScopeConfigMixin from './scopeConfigMixin'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  mixins: [MemberPersonalDataHeirarchicalMixin, ScopeConfigMixin],
  watch: {
    enrolCountryID: {
      async handler() {
        await this.loadMemberPersonalDataFieldsConfig({
          country: this.enrolCountryID,
          enrollment: 'true',
        })
      },
    },
  },
  data() {
    return {
      incomeTaxCountry: {
        params: {
          country: null,
          platform: 'backoffice',
          lookup: 'income_tax_country',
        },
      },
      preferredLanguage: {
        params: {
          country: null,
          platform: 'backoffice',
          lookup: 'preferred_language',
        },
      },
    }
  },
  computed: {
    ...mapState({
      languageOptions: state => state.globalCMP.languagesOptions.data,
      allCountriesOptions: state => state.globalCMP.allCountriesOptions.data.options,
    }),
    ...mapGetters(['getBackendConfig']),
    getUserAddress() {
      let addresses = _.cloneDeep(this.$helpers.getValue(this.enrollmentData, 'member_data.address.address_data'))
      if (addresses) {
        if (typeof addresses === 'string') {
          return JSON.parse(addresses)
        } else {
          return addresses
        }
      }
      return []
    },
    userUniqueCheckServerValidationQuery() {
      return {
        table: 'members',
        field: 'ic_passport_number',
        conditions: [
          {
            table: 'members',
            field: 'nationality_id',
            value: this.enrollmentData.member_data.details.nationality_id,
            operator: 'AND',
          },
          {
            table: 'members',
            field: 'ic_pass_type_id',
            value: this.enrollmentData.member_data.details.ic_pass_type_id,
            operator: 'AND',
          },
          {
            field: 'sponsor_id',
            value: this.enrollmentData.sponsor_user_id,
            exclude_from_query: true,
          },
          {
            field: 'country_id',
            value: this.enrolCountryID,
            exclude_from_query: true,
          },
        ],
        presets: ['enroll-member-validity'],
      }
    },
    limitDOB() {
      return moment()
        .subtract(this.countryLegalAge, 'years')
        .format('YYYY/MM')
    },
    limitIcPassportIssueDate() {
      return moment().format('YYYY/MM')
    },
    isReadOnly() {
      return this.lockSalesOrder
    },
    ...masterData({
      getMasterMapping: {
        mappings: {
          'masterKey.IC_PASSPORT_TYPE': {
            ic_pass_type_id: 'masterData.ID',
          },
          'masterKey.GENDER': {
            gender_id: 'masterData.GENDER_MALE',
          },
          'masterKey.ETHNIC_GROUP': {
            ethnic_group_id: 'masterData.ETHNIC_GROUP_MALAY',
          },
          'masterKey.MARITAL_STATUS': {
            martial_status_id: 'masterData.MARITAL_STATUS_SINGLE',
          },
          'masterKey.PREFERRED_CONTACT': {
            preferred_contact_id: 'masterData.PREFERRED_CONTACT_EMAIL',
          },
        },
      },
    }),
  },
  async mounted() {
    await this.getMasterMapping()
    await this.getLanguagesAction({
      country_id: this.enrolCountryID,
    })
    if (this.$route.query.autofill) {
      this.setRandomEnrollmentData()
    }
  },
  methods: {
    ...mapActions(['getLanguagesAction', 'setBackendConfig']),
    setRandomEnrollmentData() {
      // Details
      let randomString = moment().format('DDMMYYhmmss')
      this.enrollmentData.member_data.details.name = `Enrollment Test+${randomString}`
      this.enrollmentData.member_data.details.nationality_id = this.$helpers.getValue(
        this.countriesOptions,
        '[0].value',
        1
      )
      this.enrollmentData.member_data.details.ic_pass_type_id = this.ic_pass_type_id
      this.enrollmentData.member_data.details.ic_passport_number = randomString
      this.enrollmentData.member_data.details.date_of_birth = '2000/06/21'

      // Info
      this.enrollmentData.member_data.information.language_id = this.$helpers.getValue(
        this.languageOptions,
        '[0].value',
        1
      )
      this.enrollmentData.member_data.information.gender_id = this.gender_id
      this.enrollmentData.member_data.information.ethnic_group_id = this.ethnic_group_id
      this.enrollmentData.member_data.information.martial_status_id = this.martial_status_id

      // Contact
      this.enrollmentData.member_data.contact_info.preferred_contact_id = this.preferred_contact_id
      this.enrollmentData.member_data.contact_info.email = `enrollment.test.${randomString}@test.com`
    },
    async setIncomeTaxCountryInfo() {
      if (
        this.enrollmentData.member_data.details.nationality_id === 1 &&
        this.enrollmentData.member_data.details.membership_type === 1
      ) {
        this.enrollmentData.member_data.details.ic_pass_type_id = 216
      }
      if (this.scopeEnableFeature('isIncomeTaxCountryFieldEnableBinding', 'general.feature')) {
        let nationalityID = this.enrollmentData.member_data.details.nationality_id
        await this.setBackendConfig(
          this.$helpers.makeQueryString({ ...this.incomeTaxCountry.params, ...{ country: nationalityID } })
        )
        let incomeTaxCountryID = this.$helpers.getValue(this.getBackendConfig('income_tax_country'), '[0]', null)
        this.enrollmentData.member_data.details.income_tax_country_id = incomeTaxCountryID
        let country = this.allCountriesOptions.find(item => item.value === incomeTaxCountryID)
        if (country) {
          this.enrollmentData.member_data.details.income_tax_country.name = country.label
          this.enrollmentData.member_data.details.income_tax_country.code_iso_2 = country.code_iso_2
        }
      }
    },
    async setPreferredLanguage(countryID = null) {
      await this.setBackendConfig(
        this.$helpers.makeQueryString({ ...this.preferredLanguage.params, ...{ country: countryID } })
      )
      this.enrollmentData.member_data.information.language_id = this.getBackendConfig(
        'preferred_language',
        'mapping_id'
      )
    },
  },
}
